import Paola from '../../pages/paola/Paola'

import PrefixEnum from '../prefixes'

export default Object.freeze([{ path: PrefixEnum.PAOLA, component: Paola }])
